import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as yup from "yup";
import DataForm from "components/UI/form/DataForm";
import { addComplexDataAction, fetchDataAction, reset, setAlert } from "store/features/coreSlice";
import PropTypes from "prop-types";
import UpdateRecord from "helpers/compare";
import { useTranslation } from "react-i18next";
import dataVal from "../../dataVal.json";

const PageForm = ({ updateHandlerVal, pageNum, url }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { userInfo } = useSelector((state) => state.auth);

  const { formproducts, formpublisher, limit, formbuying, formstoresPlaces } = useSelector(
    (state) => state.core
  );

  const [data, setData] = useState([]);
  const [initialValues, setInitialValues] = useState(dataVal.initialValues);
  const [distributions, setDistributions] = useState([]);
  const [gifts, setGifts] = useState([]);
  const [publisherId, setPublisherId] = useState(null);
  const [bookId, setBookId] = useState(null);

  const orgData = () => {
    setData([
      {
        type: "Select",
        optionTitle: "arabic_title",
        name: "publisher",
        id: "publisher",
        label: "publisher",
        data: formpublisher,
        size: 6,
        title: "publisher",
      },
      {
        type: "Select",
        optionTitle: "arabic_title",
        name: "book_id",
        id: "book_id",
        label: "book_id",
        data: formproducts,
        size: 6,
        title: "book",
      },
      {
        type: "Select",
        optionTitle: "buying_date",
        optionTitle1: "notes",
        name: "buying_id",
        id: "buying_id",
        label: "buying_id",
        data: formbuying,
        size: 4,
        title: "buying",
      },
      {
        type: "Select",
        optionTitle: "title",
        name: "place_id",
        id: "place_id",
        label: "place_id",
        data: formstoresPlaces,
        size: 4,
        title: "place",
      },
      {
        type: "TextField",
        name: "count",
        id: "count",
        label: "count",
        size: 4,
        title: "count",
      },
      {
        type: "TextArea",
        name: "notes",
        id: "notes",
        label: "notes",
        maxRows: 4,
        minRows: 4,
        size: 12,
        title: "notes",
      },
    ]);
  };

  const resetForm = () => {
    setPublisherId(null);
    setBookId(null);
  };

  const setFieldSelectedValue = (name, values) => {
    if (name === "publisher") {
      setPublisherId(values.id);
      dispatch(
        fetchDataAction({
          url: `items/products?fields=id,arabic_title,publisher&filter[publisher]=${values.id}`,
          varName: "formproducts",
        })
      );
    }
    if (name === "book_id") {
      dispatch(
        fetchDataAction({
          url: `items/buying?fields=id,buying_date,stores.count,stores.id,count,notes&filter[book_id]=${values.id}`,
          varName: "formbuying",
        })
      );
      setBookId(values.id);
    }
  };

  const onChangeSelectInputs = (name, text) => {
    if (name === "publisher") {
      dispatch(
        fetchDataAction({
          url: `items/publisher?fields=id,arabic_title&filter[arabic_title][${
            text ? `contains]=${text}` : "nempty]=true"
          }&limit=${limit}`,
          varName: "formpublisher",
        })
      );
    }

    let urlVal;
    if (name === "book_id") {
      urlVal = `items/products?fields=id,arabic_title&filter[arabic_title][${
        text ? `contains]=${text}` : "nempty]=true"
      }&limit=${limit}`;
      if (publisherId) urlVal += `&filter[publisher]=${publisherId}`;
      dispatch(
        fetchDataAction({
          url: urlVal,
          varName: "formproducts",
        })
      );
    }

    if (name === "buying_id") {
      urlVal = `items/buying?fields=id,buying_date&filter[buying_date][${
        text ? `contains]=${text}` : "nempty]=true"
      }&limit=${limit}`;
      if (bookId) urlVal += `&filter[book_id]=${bookId}`;

      dispatch(
        fetchDataAction({
          url: urlVal,
          varName: "formbuying",
        })
      );
    }
  };

  const getData = (dataNeeded) => {
    dataNeeded.forEach((element) => {
      let urlVal;
      if (element === "stores_places") {
        urlVal = `items/${element}?limit=${limit}`;
        if (!userInfo.all_stores) urlVal += `&filter[users.user_id][eq]=${userInfo.id}`;
        dispatch(
          fetchDataAction({
            url: urlVal,
            varName: `formstoresPlaces`,
          })
        );
      } else
        dispatch(
          fetchDataAction({
            url: `items/${element}?limit=${limit}`,
            varName: `form${element}`,
          })
        );
    });
  };

  const onUpdateHandler = (name, values, copy) => {
    if (values.buying_id?.book_id?.publisher) {
      setFieldSelectedValue("publisher", values.buying_id.book_id.publisher);
      onChangeSelectInputs("publisher", values.buying_id.book_id.publisher.arabic_title);
    }
    if (values.buying_id?.book_id) {
      setFieldSelectedValue("book_id", values.buying_id.book_id);
    }
    getData(["stores_places"]);
    setDistributions(values.distributions);
    setGifts(values.gifts);
    setInitialValues({
      id: copy ? null : values.id,
      book_id: values.buying_id.book_id,
      publisher: values.buying_id.book_id.publisher,
      buying_id: values.buying_id,
      count: values.count,
      place_id: values.place_id,
      notes: values.notes,
    });
  };

  const setPayload = ({ files, ...values }) => {
    let count = 0;
    let count1 = 0;
    if (values.id) {
      distributions.forEach((element) => {
        count1 += element.count;
        element.returns.forEach((element1) => {
          count1 -= element1.count;
        });
      });
      gifts.forEach((element) => {
        count1 += element.count;
      });
    }

    values.buying_id.stores.forEach((element) => {
      if (element.id !== values.id) {
        count += element.count;
      }
    });

    if (
      (values.id === null ||
        values.count === initialValues.count ||
        (values.id && count1 <= values.count)) &&
      values.buying_id.count - (+values.count + count) >= 0
    ) {
      const payloadData = {};
      const lastData = values.id ? UpdateRecord(values, initialValues) : values;
      Object.keys(lastData).forEach((key) => {
        if (lastData[key] && typeof lastData[key] === "object") payloadData[key] = lastData[key].id;
        else if (values.id || lastData[key]) payloadData[key] = lastData[key];
      });
      delete payloadData.publisher;
      delete payloadData.book_id;
      const req = {
        id: values.id,
        file: null,
        origin: {
          data: Object.keys(payloadData).length === 0 ? null : payloadData,
          table: "stores",
        },
        getInfo: {
          url: `${url}&meta=*&limit=${limit}&page=${pageNum}`,
          varName: "stores",
        },
      };
      setInitialValues(values);

      dispatch(addComplexDataAction(req));
      resetForm();
    } else
      dispatch(
        setAlert({
          status: "error",
          content: t("countError"),
        })
      );
  };

  useEffect(() => {
    if (updateHandlerVal) {
      onUpdateHandler(updateHandlerVal.name, updateHandlerVal.value, updateHandlerVal.isCopy);
    } else {
      getData(dataVal.oterData);
    }
    return () => {
      resetForm();
      dispatch(reset({ alias: "form", data: ["products", "publisher", "buying", "storesPlaces"] }));
    };
  }, []);

  useEffect(() => {
    if (formproducts && formpublisher && formbuying && formstoresPlaces) orgData();
  }, [formproducts, formpublisher, formbuying, formstoresPlaces]);

  if (data.length === 0) {
    return null;
  }

  return (
    <DataForm
      yupObj={{
        buying_id: yup.mixed("required").required("required").nullable(),
        place_id: yup.mixed("required").required("required").nullable(),
        count: yup
          .number("must be number")
          .required("required")
          .typeError("must be a number")
          .positive("must be greater than zero")
          .nullable(),
      }}
      resetData={resetForm}
      name="research"
      data={data}
      initialValues={initialValues}
      setPayload={setPayload}
      setFieldSelectedValue={setFieldSelectedValue}
      onChange={onChangeSelectInputs}
      defaultInitialValues={dataVal.initialValues}
    />
  );
};

PageForm.propTypes = {
  updateHandlerVal: PropTypes.objectOf(PropTypes.any),
  pageNum: PropTypes.number.isRequired,
  url: PropTypes.string.isRequired,
};

PageForm.defaultProps = {
  updateHandlerVal: null,
};
export default PageForm;
